import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path fill-rule="evenodd" d="M26.45 7.678c.591-.64.137-1.678-.735-1.678H22.12l1.698-2.426a1 1 0 0 0-1.638-1.147L19.679 6H6.283c-.872 0-1.326 1.038-.735 1.678l9.454 10.242A1.004 1.004 0 0 0 15 18v8h-4a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2h-4v-8c0-.027 0-.053-.003-.08L26.45 7.678zM19.32 10h2.265l1.846-2H20.72l-1.4 2zm-1.041-2-1.4 2h-6.466L8.567 8h9.712z" clip-rule="evenodd" stroke="none"></path>';
export var MartiniGlassSVG = function MartiniGlassSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
MartiniGlassSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MartiniGlassSVG);